<!-- 编辑弹窗部分 -->
<template>
  <div>
    <a-drawer
      v-if="props.visible"
      placement="right"
      :width="726"
      :visible="props.visible"
      :body-style="{ padding: '24px 0', paddingBottom: data.paddBottom }"
      class="drawer"
      @close="cancelClick"
    >
      <template #title>
        <div class="mrTitle">
          <div>{{ data.current === 1 ? '预览诊疗记录' : '补充诊疗记录' }}</div>
          <div class="baseInfo">
            (
            <span class="name">{{ data.form.patientName }}</span>
            <span v-if="data.form.patientGender">{{ ['女', '男'][data.form.patientGender] }}</span>
            <span v-if="data.form.patientGender && data.form.patientAge">·</span>
            <span v-if="data.form.patientAge">{{ data.form.patientAge }}岁</span>
            )
          </div>
        </div>
      </template>
      <a-spin :spinning="data.loading">
        <formItem
          v-if="data.current === 0"
          :id="props.id"
          :formList="data.medicalHistoryList"
          :toRequired="data.toRequired"
          :current="data.current"
          @validateChange="validateChange"
          :formProp="data.form"
          :rulesProp="data.rules"
          fromVal="blformRef"
          ref="formRef"
          :doctorInProject="doctorInProject"
          :isDrug="data.form.isOpenDrug"
          :isOcr="data.form.scanOcrType === 1"
          @selectChange="selectChange"
          @switchClick="switchClick"
          @recPrescriptionOcr="recPrescriptionOcr"
        >
          <template v-slot:items="{ formItem }">
            <!-- 就诊诊断 -->
            <a-row
              :gutter="16"
              type="flex"
              justify="space-between"
              align="bottom"
              v-if="formItem.key == 'offlineDiagnosis'"
            >
              <a-col :span="24">
                <a-form-item :name="formItem.key">
                  <template v-slot:label>
                    <span class="formTitle">
                      {{ formItem.title }}
                      （
                      <span class="formShowTxt">
                        当前您已选择
                        <span class="formShowTxtNum">{{ data.allDiagnose.length }}</span>
                        个诊断
                        <span v-if="data.allDiagnose && data.allDiagnose.length >= 10">
                          ；不可选择或者是输入
                        </span>
                        ）
                      </span>
                    </span>
                    <a-tooltip placement="top">
                      <template #title>
                        <span>当前选用最多为10个诊断</span>
                      </template>
                      <div class="questionzdClass z-fixed-c">?</div>
                    </a-tooltip>
                  </template>
                  <div class="diagnose" v-if="formItem.key === 'offlineDiagnosis'">
                    <a-input-group compact style="display: flex">
                      <a-select
                        class="selectWidth"
                        v-model:value="data.diagnoseSelect"
                        :options="data.diagnoseOptions"
                        @change="selectDiagnoseChange"
                      ></a-select>
                      <a-select
                        style="flex: 1"
                        id="giftNameLimit"
                        v-if="[0, 1, 2].includes(data.diagnoseSelect)"
                        class="giftNameLimitWidth"
                        v-model:value="
                          data.form[data.diagnoseOptions[data.diagnoseSelect === 2 ? 1 : 0].key]
                        "
                        :filter-option="[2].includes(data.diagnoseSelect)"
                        :mode="data.diagnoseSelect === 2 ? 'tags' : 'multiple'"
                        placeholder="请输入诊断"
                        @change="diagnoseChange(false, $event)"
                        @search="getDiagnosisList"
                        :labelInValue="true"
                        optionFilterProp="label"
                        :options="data.diagnosis"
                        :notFoundContent="
                          [0, 1].includes(data.diagnoseSelect)
                            ? '暂无搜索数据，请输入有效内容'
                            : false
                        "
                      >
                        <template #option="{ value: val, label, type, alias, disabled }">
                          <div role="img" :aria-label="val">
                            <div class="optionsClass" :style="{ opacity: disabled ? 0.4 : 1 }">
                              <div class="z-fixed-c">
                                <div
                                  v-if="type"
                                  :class="[type == 1 ? 'diagnosisCType' : 'diagnosisZType']"
                                >
                                  {{ getDiagnosisName(type) }}
                                </div>
                              </div>
                              <div class="diagnosisRight">
                                <div
                                  class="elip--multiple diagnosisLabel"
                                  style="-webkit-line-clamp: 2"
                                >
                                  {{ label }}
                                </div>
                                <div v-if="alias" class="diagnosisAlias">{{ alias }}</div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </a-select>
                    </a-input-group>
                    <div
                      class="diagnoseIN"
                      v-if="
                        data.allDiagnose.length > 0 ||
                        (data.historyDiagnosis[data.diagnoseSelect] &&
                          data.historyDiagnosis[data.diagnoseSelect].length > 0)
                      "
                    >
                      <div
                        class="chooseGrid"
                        v-if="data.allDiagnose && data.allDiagnose.length > 0"
                      >
                        <div class="left">当前选用</div>
                        <div
                          class="right atPresent"
                          v-if="data.allDiagnose && data.allDiagnose.length > 0"
                        >
                          <a-tag
                            class="aTagClass"
                            v-for="(item, index) in data.allDiagnose"
                            :key="index"
                          >
                            <span
                              v-if="getDiagnosisName(item.type)"
                              :class="[item.type == 1 ? 'diagnosisCText' : 'diagnosisZText']"
                            >
                              ({{ getDiagnosisName(item.type) }})
                            </span>
                            <span>{{ item.label }}</span>
                          </a-tag>
                        </div>
                        <div v-else class="noneTxt">无</div>
                      </div>
                      <div
                        class="chooseGrid"
                        v-if="
                          data.historyDiagnosis[data.diagnoseSelect] &&
                          data.historyDiagnosis[data.diagnoseSelect].length > 0 &&
                          data.diagnoseSelect !== 2
                        "
                      >
                        <div class="left">历史选用</div>
                        <div class="right">
                          <span
                            class="historySpan btm"
                            v-for="(item, index) in data.historyDiagnosis[data.diagnoseSelect]"
                            :key="index"
                            :style="item.isChecked ? data.checkClass : ''"
                            @click="chooseHistory(item)"
                          >
                            <span
                              :class="[
                                item.diagnosisType == 1 ? 'diagnosisCText' : 'diagnosisZText'
                              ]"
                            >
                              ({{ getDiagnosisName(item.diagnosisType) }})
                            </span>
                            {{ item.diagnosisName }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
            <!-- 选择就诊人 -->
            <a-row
              :gutter="16"
              type="flex"
              justify="space-between"
              align="bottom"
              style="margin-left: 2px"
              v-else-if="formItem.key == 'patientProfile'"
            >
              <PatientProfilePicker
                :ucPatientId="params.ucPatientId"
                :ucDoctorId="params.ucDoctorId"
                :businessType="3"
                @handleSelect="handleSelect"
              />
            </a-row>
            <!-- 预约复诊 -->
            <a-row
              :gutter="16"
              type="flex"
              justify="space-between"
              align="bottom"
              v-else-if="formItem.key == 'retreatment'"
            >
              <a-col :span="24">
                <a-form-item :name="formItem.key">
                  <div class="retreatContent">
                    <div class="reHead">
                      <div>
                        <span class="required">预约复诊</span>
                        <span class="tips">请添加复诊时分别向医生/患者确认复诊日期</span>
                      </div>
                      <div class="action">
                        <a href="#" @click="goTreatSheet">查看复诊日程</a>
                        <DoctorScheduleSheet :bindUcDoctorId="`${props.params.ucDoctorId}`" />
                        <ChatToRole
                          v-if="communicatePatient"
                          receiver="patient"
                          @ChatTo="emit('savaData')"
                        />
                        <ChatToRole
                          v-if="communicateDoctor"
                          receiver="doctor"
                          @ChatTo="emit('savaData')"
                        />
                      </div>
                    </div>
                    <div class="reContent">
                      <a-form-item
                        class="item"
                        name="reserveDate"
                        label="复诊日期"
                        :rules="{ required: !data.notNeedReserve, message: '请选择复诊日期' }"
                      >
                        <a-date-picker
                          style="width: 180px"
                          v-model:value="data.form.reserveDate"
                          @change="setTreatDate"
                          :disabled-date="disabledDate"
                          :showToday="false"
                        >
                          <template #dateRender="{ current }">
                            <div :class="['ant-calendar-date', calendarCustomStyle(current)]">
                              {{ current.date() }}
                            </div>
                          </template>
                        </a-date-picker>
                      </a-form-item>
                      <a-form-item
                        class="item"
                        name="reserveDateDetail"
                        :rules="{ required: !data.notNeedReserve, message: '请选择复诊时段' }"
                        label="复诊时段"
                      >
                        <a-radio-group
                          v-model:value="data.form.reserveDateDetail"
                          @change="changeDateDetailAndType"
                        >
                          <a-radio :value="1">上午</a-radio>
                          <a-radio :value="2">下午</a-radio>
                        </a-radio-group>
                      </a-form-item>
                      <a-form-item
                        class="item"
                        name="revisitType"
                        label="复诊方式"
                        :rules="{ required: !data.notNeedReserve, message: '请选择复诊方式' }"
                      >
                        <a-radio-group
                          v-model:value="data.form.revisitType"
                          :disabled="data.doctorRecordPassed"
                          @change="changeDateDetailAndType"
                        >
                          <a-radio :value="1">线上问诊</a-radio>
                          <a-radio :value="2">门诊就诊</a-radio>
                        </a-radio-group>
                      </a-form-item>
                    </div>
                  </div>
                  <div class="line"></div>
                  <div class="notreat">
                    <a-checkbox v-model:checked="data.notNeedReserve" @change="hanldeCheck">
                      遵医嘱复诊
                    </a-checkbox>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
            <!-- 剩余内容开关 -->
            <a-row
              :gutter="16"
              type="flex"
              justify="space-between"
              align="bottom"
              v-else-if="formItem.key == 'switchBlock'"
            >
              <div class="retreatContent">
                <div class="reHead">
                  <span class="tit">补充其他信息</span>
                  <a href="#" @click="effectFormItemVisible(false)">
                    {{ data.expend ? '收起' : '展开' }}
                  </a>
                </div>
              </div>
            </a-row>
            <!-- 用药情况 -->
            <a-row
              :gutter="16"
              type="flex"
              justify="space-between"
              align="bottom"
              v-else-if="formItem.key == 'drugCheck' || 'drugInput'"
            >
              <a-col :span="24">
                <a-form-item :name="`${data.isShowDrugtype}`" class="formItemClass">
                  <template v-slot:label>
                    <div class="z-fixed formLabel">
                      <span class="formTitle">
                        {{ formItem.title }}
                      </span>
                      <span class="formImgShowTxt" v-if="data.isShowDrugtype === 'drugCheck'">
                        （处方药品可多选）
                      </span>
                      <span class="formImgShowTxt" v-else>（最多可添加10个药品）</span>
                      <div
                        v-if="data.isShowDrugtype === 'drugInput'"
                        type="link"
                        class="drugBtn"
                        @click="drugAdd"
                      >
                        添加药品
                      </div>
                    </div>
                  </template>
                  <div v-if="data.isShowDrugtype === 'drugCheck'">
                    <a-checkbox-group v-model:value="data.drugCheckout">
                      <a-checkbox
                        v-for="(item, index) in data.drugCheckout"
                        :key="index"
                        :value="item"
                        :disabled="true"
                      >
                        {{ item }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </div>
                  <div v-else>
                    <a-row
                      v-for="i of data.activeKey"
                      :key="i"
                      :gutter="16"
                      :style="{ marginTop: i === 1 ? '0' : '16px' }"
                      justify="center"
                    >
                      <a-col
                        :span="data.form.scanOcrType === 1 ? 14 : 22"
                        v-if="data.form && data.form.drugInput"
                      >
                        <a-input
                          v-if="data.form.scanOcrType === 1"
                          class="inputHeight"
                          v-model:value="(data.form.drugInput[i - 1] || {}).name"
                          placeholder="请输入处方药品(最多输入30个字)"
                          :maxlength="30"
                          allowClear
                        />
                        <a-input
                          v-else
                          class="inputHeight"
                          v-model:value="(data.form.drugInput[i - 1] || {}).name"
                          placeholder="请输入处方药品(最多输入30个字)"
                          :maxlength="30"
                          allowClear
                        />
                      </a-col>
                      <a-col
                        :span="8"
                        v-if="data.form && data.form.drugInput && data.form.scanOcrType === 1"
                      >
                        <a-input-number
                          class="inputHeight"
                          v-model:value="(data.form.drugInput[i - 1] || {}).amount"
                          placeholder="数量"
                          :min="1"
                          :max="999"
                          :precision="0"
                          style="width: 100%"
                        />
                      </a-col>
                      <a-col :span="2">
                        <div class="delClass" @click="drugDel(i - 1)">删除</div>
                      </a-col>
                    </a-row>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </formItem>
        <div v-if="data.current === 1">
          <previewMedicalRecords :formProp="data.form"></previewMedicalRecords>
        </div>
      </a-spin>
      <div class="footer">
        <a-button class="btnMarginLeft" @click="deleteRecord" v-if="isCanDelete">
          删除诊疗记录
        </a-button>
        <a-button class="btnMarginLeft" @click="cancelClick">取消</a-button>
        <a-button class="btnMargin" v-if="data.current > 0" @click="prev">上一步</a-button>
        <a-button
          class="btnMargin"
          v-if="data.current < data.steps.length - 1"
          type="primary"
          @click="next"
        >
          下一步
        </a-button>

        <a-button
          class="btnMargin"
          v-if="data.current == data.steps.length - 1"
          type="primary"
          :loading="data.btnLoading"
          @click="handleDueType"
        >
          保存
        </a-button>
      </div>
      <ModalTips @on-ok="checkDoctorAppoint" ref="ModalTipsDOM"></ModalTips>
    </a-drawer>
    <SetRetreatment ref="treatmentRef" isSheet />
  </div>
</template>
<script setup>
import ModalTips from '@/views/WorkPlace/Container/chat/components/chatAppoint/ModalTips.vue'
import {
  reactive,
  defineProps,
  defineEmits,
  watch,
  ref,
  nextTick,
  computed,
  createVNode,
  defineExpose
} from 'vue'
import formItem from './formItem.vue'
import previewMedicalRecords from './previewMedicalRecords.vue'
import {
  medicalHistoryList,
  formItemType,
  getActivityList,
  effectShow
} from '../hooks/useComponent'
import {
  getDiagnosis,
  getHistoryList,
  getOfflineCaseInit,
  saveOfflineCase,
  updateOfflineCaseV2,
  offLineRecordDetail,
  isDetailIllnessPre,
  detailRecordPermission,
  recentDiagnosisInfo,
  deleteMedicalRecord,
  recognizePrescriptionOcr,
  diagnosisReconsultDate,
  queryDoctorPass
} from '@/api/HealthRecord/index.js'
import {
  queryCureReserveTag,
  queryCureReserveVO,
  queryLimitAndDefaultDate,
  isDoctorJoinProject
} from '@/api/workPlace/retreatment.js'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
import moment from 'moment'
import { debounce } from 'lodash-es'
import { trimSpace } from '@/utils/index'
import DoctorScheduleSheet from '@/components/Retreatment/doctorScheduleSheet.vue'
import ChatToRole from '@/components/Retreatment/chatToRole.vue'
import SetRetreatment from '@/views/WorkPlace/Container/chat/components/retreatment/setRetreatment.vue'
import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import PatientProfilePicker from '@/components/PatientProfilePicker'
import { getProfileList } from '@/api/workPlace/workOrder'
import axios from 'axios'
import { getToken, TokenKey } from '@/utils/auth'

const store = useStore()
const props = defineProps({
  params: {
    type: Object,
    default: () => ({
      ucPatientId: null,
      patientId: null,
      ucDoctorId: null,
      doctorId: null,
      reserveEntry: 3 //2-推送补充诊疗记录卡片 3-患者档案补充诊疗记录
    })
  },
  id: {
    type: String,
    value: ''
  },
  visible: {
    type: Boolean,
    value: false
  },
  // NOTE: 在患者复诊日程中，添加诊疗记录不需要提交接口
  needAPI: {
    type: Boolean,
    default: true
  },
  keepAlive: {
    //支持查看历史数据
    type: Boolean,
    default: false
  },
  isCanDelete: {
    // 能否删除病历
    type: Boolean,
    default: false
  },
  // 沟通医生
  communicateDoctor: { type: Boolean, default: true },
  // 沟通患者
  communicatePatient: { type: Boolean, default: true }
})
const emit = defineEmits(['cancelClick', 'savaData'])
const data = reactive({
  notNeedReserve: false, // 遵医嘱复诊
  expend: false, //是否展开其他信息
  reserveDate: '', // 复诊日期
  reserveDateDetail: '', // 复诊时段
  revisitType: '', // 复诊方式
  doctorRecordPassed: false, // 医生是否备案过
  diagnosisCache: new Map(), //诊断类型存储map对象
  medicalHistoryList: [],
  paddBottom: '80px',
  btnLoading: false,
  loading: true,
  diagnoseSelect: 0,
  allDiagnose: [], //当前选择诊断
  allDiagnoseList: [],
  diagnosis: [], //搜索获取诊断数据
  historyDiagnosis: [], //历史诊断
  checkClass: {
    background: '#E6F7FF'
  },
  toRequired: 0, //为了校验 和current不一致时就会触发校验
  toRequiredRs: true, // 校验结果
  isNext: false, //是否是下一步
  offlineCaseDetail: '', //线上病历详情
  isShowDrugtype: 'drugInput', //显示处方药品的展示方式
  current: 0, //步骤条
  activeKey: 1, //默认药品的条数
  activityList: getActivityList(),
  saveDataKey: [],
  form: {},
  rules: {
    offlineDiagnosis: {
      required: true,
      trigger: ['change', 'blur'],
      type: 'array',
      validator: diagnosisValidatePass
    },
    drugCheck: {
      required: true,
      trigger: ['change'],
      validator: checkValidatePass
    },
    drugInput: {
      required: true,
      trigger: ['change'],
      type: 'array',
      validator: validatePass
    }
  },
  drugCheckout: [],
  steps: [
    {
      title: '病历信息'
    },
    {
      title: '预览病历'
    }
  ],
  diagnoseOptions: [
    {
      value: 0,
      label: '搜索诊断',
      key: 'group_0'
    }
    //{
    //value: 2,
    //  label: '自定义诊断',
    //key: 'group_2'
    //}
  ],
  preId: '',
  modifyReserveDateFlag: 0 //是否修改复诊日
})

const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)

const calendarCustomStyle = computed(() => {
  return function (current) {
    let className = null
    className = ''
    const curD = moment(current).format('YYYY-MM-DD')
    const date = appointList.value.find(f => f.reserveDate === curD)
    if (date) {
      className = date.reserveTag === 1 ? 'calendar-custom' : 'calendar-custom-passed'
    }
    return className
  }
})

// 查看复诊日期表
const treatmentRef = ref(null)

function goTreatSheet() {
  const hasProps =
    props.params?.ucPatientId &&
    props.params?.ucDoctorId &&
    props.params?.doctorId &&
    props.params?.patientId
  if (hasProps) {
    const userInfo = {
      ucPatientId: props.params?.ucPatientId || curOrder.value.patientInfo?.ucUserId || null,
      ucDoctorId: props.params?.ucDoctorId || curOrder.value.doctorInfo?.ucUserId || null,
      doctorId: props.params?.doctorId || curOrder.value.doctorInfo.businessId,
      patientId: props.params?.patientId || curOrder.value.patientInfo.businessId
    }
    treatmentRef.value.treatmentInit(null, null, userInfo)
  } else {
    treatmentRef.value.treatmentInit()
  }
}

const appointList = ref([])
const fetchReverseList = () => {
  appointList.value = []
  const params = {
    ucPatientId: props.params?.ucPatientId || curOrder.value.patientInfo?.ucUserId || null,
    reserveDateMin: null,
    reserveDateMax: null,
    ucDoctorId: props.params?.ucDoctorId || curOrder.value.doctorInfo?.ucUserId || null,
    prescribe: data.current !== 1
  }
  queryCureReserveTag(params).then(result => {
    appointList.value = result
  })
}

// 通过后端设置可选时间范围
const disabledDate = current => {
  return current && current < moment(reverseDatelimit.value)
}
const effectFormItemVisible = (isEdit = false) => {
  !isEdit && (data.expend = !data.expend)
  data.medicalHistoryList.forEach(item => {
    if (effectShow.includes(item.key)) {
      item.isExpend = isEdit ? true : !item.isExpend
    }
  })
}

const formRef = ref(null)
const hanldeCheck = () => {
  if (data.notNeedReserve) {
    data.form.reserveDate = null
    data.form.reserveDateDetail = null
    data.form.revisitType = null
    formRef.value.clearValidForTreat()
  }
}

const setTreatDate = e => {
  data.notNeedReserve = false
  data.modifyReserveDateFlag = 1
  data.form.reserveDate = e ? moment(e).format('YYYY-MM-DD') : ''
  console.log('data.form.reserveDate', data.form.reserveDate)
}

const changeDateDetailAndType = () => {
  data.notNeedReserve = false
  // data.modifyReserveDateFlag = 1
}

const getType = str => {
  const index = str.indexOf('_')
  return Number(str.substr(index + 1, str.length)) + 1
}
const changeDiagnosis = (list, type) => {
  const groupList = list.map(item => {
    const diagnosisType = data.diagnosisCache.get(item.value)
    return {
      diagnosisId: type !== 3 ? item.value : '',
      diagnosisName: item.label,
      diagnosisType: diagnosisType || diagnosisType + '' === '1' ? diagnosisType : 3
    }
  })
  return groupList
}
// 解析保存数据的参数
const saveData = () => {
  return new Promise(resolve => {
    data.btnLoading = true
    data.form.patientProfileId = data.form.patientProfileId || props.params.ucPatientId
    // 图片去除空数据
    data.form.checklistFileList = trimSpace(data.form.checklistFileList)
    data.form.imgUrlList = trimSpace(data.form.imgUrlList)
    data.form.ocrImgUrlList = trimSpace(data.form.ocrImgUrlList)
    if (!data.form.operateType) {
      data.form.operateType = 5
    }
    data.saveDataKey = {
      ucDoctorId: Number(props.params.ucDoctorId),
      ...data.form,
      uploader: store.getters.userInfo.realName
    }
    const dataParams = { ...data.saveDataKey }
    console.log('dataParams', dataParams)
    dataParams.diagnosisList = []
    // dataParams.patientPermission = Number(sessionStorage.getItem('patientPermission'))
    data.diagnoseOptions.map(item => {
      if (data.saveDataKey[item.key]) {
        dataParams[item.key] = changeDiagnosis(data.saveDataKey[item.key], getType(item.key))
        dataParams.diagnosisList.push(...dataParams[item.key])
      }
    })
    //处方药品
    //没有老数据了 只要跳过就清空无论是不是编辑
    const { activityId = 0 } = dataParams?.prescriptionInfo || {}
    if (activityId > 0) {
      dataParams.prescriptionInfo.medicationNames = [...data.form.drugCheck[activityId]]
    } else {
      // 将药品对象数组转换为字符串数组
      dataParams.prescriptionInfo.medicationNames =
        data.form?.drugInput?.map(drug => drug.name) || []
      // medicationNums 只在 OCR 场景下提交
      if (data.form.scanOcrType === 1) {
        dataParams.prescriptionInfo.medicationNums =
          data.form?.drugInput?.map(drug => drug.amount) || []
      } else {
        // 非OCR场景：drugInput 转换为字符串数组（不包含amount字段）
        dataParams.drugInput = data.form?.drugInput?.map(drug => drug.name) || []
      }
    }
    const spuIds = []
    data.drugCheckout.map(checkItem => {
      dataParams.prescriptionInfo.medicationNames.map(nameItem => {
        if (nameItem === checkItem.label) {
          spuIds.push(checkItem.relationId)
        }
      })
    })
    dataParams.noMedication = data.form.isOpenDrug ? 0 : 1
    data.form.inquiryTime = data.form.inquiryTime
      ? moment(data.form.inquiryTime).format('YYYY-MM-DD 00:00:00')
      : ''
    if (data.form.isOpenDrug) {
      // noMedication 暂无用药 1-是 0-否 0是用药 1是暂无用药是吗？
      dataParams.prescriptionInfo = {
        ...dataParams.prescriptionInfo,
        spuIds: spuIds //需要拼一下
      }
    } else {
      dataParams.prescriptionInfo = null
      dataParams.medicationNames = []
      dataParams['prescriptionInfo.activityId'] = ''
    }

    dataParams.fileList = []
    dataParams.healthFileList = []
    dataParams.offlineDiagnosis = ''
    dataParams.reserveDate = dataParams.reserveDate
      ? moment(dataParams.reserveDate).format('YYYY-MM-DD 00:00:00')
      : ''
    dataParams.notNeedReserve = data.notNeedReserve
    dataParams.source = 7
    dataParams.patientPermission = dataParams.patientPermission ? 1 : 0
    dataParams.doctorPermission = dataParams.doctorPermission ? 1 : 0
    dataParams.group_2 = undefined
    dataParams.group_0 = undefined
    data.btnLoading = false
    resolve(dataParams)
  })
}

const handleDueType = debounce(() => {
  saveData().then(res => {
    if (props.id) {
      res.id = props.id
      if (props.needAPI) {
        saveOfflineCaseData(res)
      } else {
        emit('savaData', 'update', res)
      }
    } else {
      data.preId && (res.preOfflineCaseId = data.preId)
      if (props.needAPI) {
        addOfflineCaseData(res)
      } else {
        props.keepAlive && cancelClick()
        emit('savaData', 'add', res)
      }
    }
  })
}, 400)

const switchClick = (e, item) => {
  if (item.key === 'isOpenDrug') {
    initFormList(e)
    // 如果关闭用药开关，清空drugInput数据
    if (!e) {
      data.form.drugInput = [{ name: '', amount: '' }]
    }
    // OCR场景下，如果关闭用药开关，清空就诊医院和就诊医生字段
    if (!e && data.form.scanOcrType === 1) {
      data.form.hospitalName = ''
      data.form.offlineDoctorName = ''
    }
  }
}
const initFormList = (e, item) => {
  // 编辑下需要判断是否医生可见 如果医生不可见则其他补充其他信息里的数据不要展示
  if (props.id && item && item.assistPermission !== 1) {
    data.medicalHistoryList.forEach(item => {
      const effectShowList = ['switchBlock', ...effectShow]
      if (effectShowList.includes(item.key)) {
        item.isShow = false
      }
    })
  } else {
    data.medicalHistoryList.map(item => {
      if (item.form === 'drug') {
        // OCR专属字段（就诊医院、就诊医生）只在OCR场景下显示
        const isOcrOnlyField = ['hospitalName', 'offlineDoctorName'].includes(item.key)
        if (isOcrOnlyField) {
          item.isShow = e && data.form.scanOcrType === 1
        } else {
          item.isShow = e
        }
      }
    })
  }
}
// 新增成功
const addOfflineCaseData = dataParams => {
  dataParams.id = null
  const caseParams = {
    ...dataParams,
    reserveEntry: props.params.reserveEntry,
    modifyReserveDateFlag: data.modifyReserveDateFlag,
    offlinePatientName: data.form.patientName
  }
  if (props.params.needWorkOrderId) {
    caseParams.requireFollowWorkOrderId = props.params.workOrderId
  }
  saveOfflineCase(caseParams)
    .then(async res => {
      message.success('提交成功')
      // 清空以前暂存过的历史记录
      const storageRecord = JSON.parse(sessionStorage.getItem(`SESSION_MEDICAL_RECORD`) || '{}')
      // 先获取最近一次补充诊疗记录权限设置查询接口
      const detail = await detailRecordPermission({
        ucPatientId: Number(props.params.ucPatientId),
        ucDoctorId: Number(props.params.ucDoctorId)
      })
      sessionStorage.setItem(
        `SESSION_MEDICAL_RECORD`,
        JSON.stringify({
          ...storageRecord,
          [`${patId.value}-${docId.value}-${assId}-MedicalRecord`]: {
            patientPermission: detail?.patientPermission,
            doctorPermission: detail?.doctorPermission
          }
        })
      )
      const result = {
        ...res,
        reserveDate: data.form.reserveDate,
        reserveDateDetail: data.form.reserveDateDetail,
        revisitType: data.form.revisitType,
        notNeedReserve: data.form.notNeedReserve
      }
      emit('savaData', 'add', result)
    })
    .catch(() => {
      data.btnLoading = false
    })
}
// 提交编辑前的二次确认
const editConfirm = cb => {
  Modal.confirm({
    title: '确定提交诊疗记录',
    icon: createVNode(ExclamationCircleOutlined),
    content:
      '提交后，原复诊预约单将自动取消，后续复诊将以本次提交的最新预约单为准。确认执行本次编辑操作？',
    okText: '确认',
    cancelText: '取消',
    centered: true,
    onOk: () => {
      cb && cb()
    },
    onCancel: () => {
      emit('cancelClick')
    }
  })
}
// 编辑更新成功
const saveOfflineCaseData = dataParams => {
  updateOfflineCaseV2({
    ...dataParams,
    reserveEntry: 12,
    modifyReserveDateFlag: data.modifyReserveDateFlag
  })
    .then(res => {
      message.success('保存成功')
      const result = {
        ...res,
        reserveDate: data.form.reserveDate,
        reserveDateDetail: data.form.reserveDateDetail,
        revisitType: data.form.revisitType,
        notNeedReserve: data.form.notNeedReserve
      }
      emit('savaData', 'update', result)
    })
    .catch(() => {
      data.btnLoading = false
    })
}
//选择诊断
const selectDiagnoseChange = () => {
  setIptMaxLength()
  data.diagnosis = []
  if ([0, 1].includes(data.diagnoseSelect)) {
    getHistoryDiagnosis()
  }
}
// 获取历史诊断
const getHistoryDiagnosis = () => {
  const historyParams = {
    medicationType: -1,
    // medicationType: data.diagnoseSelect + 1,
    doctorId: data.offlineCaseDetail.doctorId
  }
  getHistoryList(historyParams).then(res => {
    if (res) {
      data.historyDiagnosis[data.diagnoseSelect] = (res || []).filter(it => it.diagnosisType !== 3)
      //将历史诊断存入map对象
      res.forEach(item => data.diagnosisCache.set(item.diagnosisId, item.diagnosisType))
      //当前选用诊断
      const e = data.form[data.diagnoseOptions[data.diagnoseSelect === 2 ? 1 : 0].key]
      // 如果当前选用诊断存在，并且历史诊断的数据在已选用的诊断中出现就把状态变成已选中状态
      if (e) {
        changeArr(
          e,
          data.historyDiagnosis[data.diagnoseSelect],
          'isChecked',
          'label',
          'diagnosisName'
        )
      }
    } else {
      data.historyDiagnosis = []
    }
  })
}
const getDiagnosisName = type => {
  if (type === 1) {
    return '西医'
  } else if (type === 2) {
    return '中医'
  }
}
function getSearchForType(list, flg) {
  list.map(item => {
    item.type = data.diagnosisCache.get(item.value)
    if (flg && data.diagnosisCache.has(item.value)) {
      item.disabled = true
    }
  })
}
// 获取诊断数据
const getDiagnosisList = debounce(e => {
  const params = {
    page: 1,
    num: 500,
    keyword: e,
    // chineseMedicine: data.diagnoseSelect
    chineseMedicine: -1
  }
  if ([0, 1].includes(data.diagnoseSelect)) {
    //获取诊断  //是否中医（1是 0否 -1合并搜索）
    //获取搜索诊断数据
    getDiagnosis(params).then(res => {
      if (res[0] && res[0].result.length > 0) {
        data.diagnosis = res[0].result.map(item => {
          //如果有自定义数据，就disabled，如果有id就不disabled（如果有id说明是当前下拉选项，可以点击去除选择）
          //并且data.allDiagnose>10且不包括选过的
          const disabled = isRepetition(item.name, item.id)
          return {
            label: item.name,
            value: item.id,
            disabled: disabled,
            type: item.diagnosisType, //改前：1-中医诊断，0-西医诊断 // 改后：2-中医诊断，1-西医诊断
            alias: item.alias
          }
        })
      } else {
        data.diagnosis = []
        // let key = data.diagnoseOptions[data.diagnoseSelect].key
        // data.diagnosis = data.form[key]
      }
    })
  } else if ([2].includes(data.diagnoseSelect)) {
    //自定义诊断
    //如果当前选用中已经有非自定义诊断的名字，则把数据加入自定义的诊断options上并设置disabled为true，
    //这样就不可以自定义其他诊断定义过得诊断名
    data.form.group_0 ??= []
    data.form.group_1 ??= []
    data.diagnosis = [...data.form.group_0, ...data.form.group_1]
    getSearchForType(data.diagnosis, 'custom')
  }
}, 300)
// 查看是否有重复数据 和 当前选择大于10时返回disabled
const isRepetition = (str, id) => {
  if (data?.allDiagnose) {
    //找出当前是否有和自定义相同的数据
    const name = data.allDiagnose.find(
      // && n.label === n.value
      n => n.label === str && n.value !== id
    )
    if (name) {
      return true
    }
    // 非自定义
    if ([0, 1].includes(data.diagnoseSelect)) {
      return data.allDiagnose.length >= 10 && data.allDiagnose.findIndex(a => a.value === id) === -1
    }
  }
}
//删除一项
const removeByValue = (arr, attr, value) => {
  let index = 0
  for (const i in arr) {
    if (arr[i][attr] == value) {
      index = i
      break
    }
  }
  arr.splice(index, 1)
}
//处理历史诊断的选择和取消
const chooseHistory = item => {
  const key = data.diagnoseOptions[data.diagnoseSelect].key
  if (!item.isChecked) {
    if (data.allDiagnose.length >= 10) {
      message.error('最多添加10个诊断!')
      return
    } else {
      if (isRepetition(item.diagnosisName, item.diagnosisId)) {
        // message.warning('当前选用已存在自定义诊断"' + item.diagnosisName + '"')
        message.warning('请勿重复选择!')
        return
      }
    }
  }
  item.isChecked = !item.isChecked
  if (item.isChecked) {
    //增加  //增加的时候要判断当前选用的诊断存不存在
    const params = {
      label: item.diagnosisName,
      value: item.diagnosisId,
      type: item.diagnosisType //改前：1-中医诊断，0-西医诊断 // 改后：2-中医诊断，1-西医诊断
    }
    if (!data.form[key]) {
      data.form[key] = []
    }
    data.form[key].push(params)
    //data.allDiagnoseList.push(params)
  } else {
    //删除
    removeByValue(data.form[key], 'value', item.diagnosisId)
    removeByValue(data.allDiagnoseList, 'value', item.diagnosisId)
  }
  diagnoseChange('isHistoryClicked')
}
//改变某一项的值
function changeArr(source, target, valueKey, sourceKey, targetKey) {
  target.forEach(item => {
    item[valueKey] = source.some(
      sourceItem =>
        sourceItem[sourceKey] === item[targetKey] && sourceItem.value === item.diagnosisId
    )
  })
  return target
}

// 拼接前处理数据
const detailData = (isHistoryClicked, e) => {
  if ([0, 1].includes(data.diagnoseSelect)) {
    if (e && e.length > 0) {
      if (data?.historyDiagnosis[data.diagnoseSelect]) {
        // 如果历史诊断的数据在已选用的诊断中出现就把状态变成已选中状态
        changeArr(
          e,
          data.historyDiagnosis[data.diagnoseSelect],
          'isChecked',
          'label',
          'diagnosisName'
        )
      }
    } else {
      //如果当前诊断的历史诊断存在并且不是处理历史诊断数据拼接时
      if (data?.historyDiagnosis[data.diagnoseSelect] && !isHistoryClicked) {
        data.historyDiagnosis[data.diagnoseSelect].map(item => {
          item.isChecked = false
        })
      }
    }
  } else {
    //自定义诊断
    //判断当前输入的自定义诊断在当前选用诊断中是否存在
    if (e && e.length > 0) {
      //最后输入的一条数据
      const dataItem = e[e.length - 1]
      const isHas = isRepetition(dataItem.label, dataItem.value)
      if (isHas) {
        removeByValue(e, 'value', dataItem.label)
        message.warning('请勿重复选择!')
        return
      }
    }
  }
}
// 拼接当前诊断
// 如果 isHistoryClicked存在就是处理历史诊断的数据拼接
const diagnoseChange = (isHistoryClicked, e) => {
  setIptMaxLength()
  detailData(isHistoryClicked, e)
  //选择搜索结果将当前搜索集合存入map对象
  data.diagnosis.forEach(item => data.diagnosisCache.set(item.value, item.type))
  //拼接
  const list = []
  data.diagnoseOptions.map(item => {
    if (data.form?.[item.key]) {
      list.push(...data.form[item.key])
    }
    data.allDiagnose = list.concat(data.allDiagnoseList)
  })
  data.form.offlineDiagnosis = data.allDiagnose
  //非自定义下处理
  if ([0, 1].includes(data.diagnoseSelect)) {
    data.diagnosis.map(item => {
      //如果有自定义数据，就disabled，如果有id就不disabled（如果有id说明是当前下拉选项，可以点击去除选择）
      const disabled = isRepetition(item.label, item.value)
      item.disabled = disabled
    })
    if (data.allDiagnose.length > 0) {
      getSearchForType(data.allDiagnose)
    }
  }
  //触发校验
  if (!data.toRequiredRs) {
    if (data.form.offlineDiagnosis.length > 0) {
      data.toRequired++
      data.isNext = false
    }
  }
}
//初始化表单信息
async function formData(res = {}) {
  return new Promise(resolve => {
    let paramsForm = {
      imgUrlList: [],
      ocrImgUrlList: [],
      checklistFileList: [],
      diagnoseInput: '',
      diagnoseInputSel: [],
      ucPatientId: Number(props.params.ucPatientId),
      doctorPermission: res?.doctorPermission || true,
      drugInput: [], //输入校验
      drugCheck: {}
    }
    // 默认开启 若无返回 即设定为开启状态
    // const defaultPatientPermission = res.patientPermission === 0 ? res.patientPermission : 1
    // sessionStorage.setItem('patientPermission', defaultPatientPermission)
    data.medicalHistoryList.map(item => {
      if (res) {
        const { activityId = 0, medicationNames = [] } = res?.prescriptionInfo || {}

        res.prescriptionInfo = {
          ...res.prescriptionInfo,
          activityId: activityId > 0 ? activityId : 0
        }
        // 处理患者和医生可见和不可见,编辑下可见不可见不可以编辑
        if (['patientPermission'].includes(item.key)) {
          // item.disabled = res && res.id
          paramsForm[item.key] = !!(res && res[item.key])
        }
        // 医生可见默认为true
        paramsForm['doctorPermission'] = [null, undefined].includes(res?.doctorPermission)
          ? true
          : Boolean(res?.doctorPermission)

        if (item.key === 'patientAge') {
          item.u = res?.patientAgeUnit || '岁'
        }
        if (item.key === 'isOpenDrug') {
          if (medicationNames && medicationNames.length > 0) {
            paramsForm[item.key] = true
          } else {
            paramsForm[item.key] = false
          }
        }
        if (item.auxiliaryKey) {
          paramsForm[item.key] = res[item.auxiliaryKey]
          //初始化图片
          if (item.key === 'fileList' || item.key === 'healthFileList') {
            paramsForm[item.key] = innitImgs(res, item.auxiliaryKey) || []
            paramsForm[item.auxiliaryKey] = res[item.auxiliaryKey]
          }
        }
        if (item.key === 'offlineDiagnosis') {
          paramsForm = { ...paramsForm, ...innitDiagnosis(res) }
        }
        if (item.key === 'drugInput') {
          paramsForm = { ...paramsForm, ...drugDataDetail(res, item) }
        }
        //后期对接接口
        // noMedication 暂无用药 1-是 0-否
        paramsForm.isOpenDrug = res.noMedication == 0 ? true : false
      } else {
        if (item.keyOne) {
          paramsForm['prescriptionInfo'] = {
            activityId: 0,
            spuIds: []
          }
          paramsForm.drugCheck = {}
          paramsForm.isOpenDrug = true
          data.activeKey = 1 //默认药品的条数
        } else {
          // 处理患者和医生可见和不可见默认为false
          if (['patientPermission'].includes(item.key)) {
            paramsForm[item.key] = false
          } else {
            paramsForm[item.key] = formItemType[item.type - 1].default
          }
        }
      }
    })
    // 兼容编辑和暂存
    const { reserveDate, reserveDateDetail, revisitType } = res.cureReserveOrderVO || {}
    data.form = {
      ...res,
      ...paramsForm,
      reserveDate: reserveDate || res.reserveDate,
      reserveDateDetail: reserveDateDetail || res.reserveDateDetail,
      revisitType: revisitType || res.revisitType
    }
    console.log('data.form', res, data.form)
    props.id && (data.notNeedReserve = res.notNeedReserve)
    backFillUploadPic()
    resolve()
  }).then(() => {
    diagnoseChange()
    initFormList(data.form.isOpenDrug, res)
  })
}

//初始化处方药品信息
function drugDataDetail(res) {
  const { activityId = 0, medicationNames = [], medicationNums = [] } = res?.prescriptionInfo || {}
  const paramsForm = reactive({
    drugCheck: {}
  })
  isShowDrugtype(activityId)
  if (activityId > 0) {
    //获取活动名称列表
    // ativityMedicationList(activityId).then(() => {
    //   // 编辑临观病历的时候只展示选中的病历
    //   // data.drugCheckout.filter(it => [medicationNames].includes(it.value))
    //   data.drugCheckout = medicationNames
    //   // paramsForm.drugCheck[activityId] = medicationNames || {}
    //   paramsForm.drugInput = []
    // })
    data.drugCheckout = medicationNames || {}
    paramsForm.drugCheck[activityId] = medicationNames || {}
    paramsForm.drugInput = []
  } else {
    paramsForm.drugInput = []
    if (medicationNames.length > 0) {
      data.activeKey = medicationNames.length
      // 将字符串数组转换为对象数组
      paramsForm.drugInput = medicationNames.map((name, index) => {
        // 尝试解析 "药品名 x数量" 格式
        return { name, amount: medicationNums[index] }
      })
    } else {
      data.activeKey = 1
      // 初始化一个空的药品输入框
      paramsForm.drugInput = [{ name: '', amount: 1 }]
    }
    paramsForm.drugCheck = {}
  }
  return paramsForm
}
// 初始化诊断数据
function innitDiagnosis(res) {
  const paramsForm = {}
  //处理就诊诊端数据回显
  const changeData = res?.diagnosisList
    ? res.diagnosisList.map(item => {
        return {
          value: item?.diagnosisId ? item.diagnosisId : item.diagnosisName,
          label: item.diagnosisName,
          type: item.diagnosisType
        }
      })
    : []
  //对诊断进行分组
  const gropList = handleSameTypeGroup(changeData)
  //赋值
  const isHaveValues = []
  for (const key in gropList) {
    paramsForm[key] = gropList[key]
    //处理有诊断数据时诊断默认为哪个诊断
    if (gropList[key].length > 0) {
      isHaveValues.push(key)
    }
  }
  // if (isHaveValues.length > 0) {
  //   data.diagnoseSelect = Number(isHaveValues[0].split('group_')[1])
  // }
  data.diagnoseSelect = 0
  return paramsForm
}
//数据分组
function handleSameTypeGroup(dataList) {
  const obj = {} // 定义空对象用于获取同类type数据
  if (dataList.length > 0) {
    for (const item of dataList) {
      const type = [1, 2].includes(item.type) ? 0 : 2
      if (obj['group_' + type]) {
        obj['group_' + type].push(item)
      } else {
        obj['group_' + type] = [item]
      }
    }
  }
  return obj
}
//获取活动名称列表
// const ativityMedicationList = id => {
//   return getActivityMedicationList({ activityTemplateId: id }).then(res => {
//     if (res.length > 0) {
//       data.drugCheckout = res.map(item => {
//         return {
//           activityType: item.activityType,
//           label: item.relationName,
//           value: item.relationName,
//           relationId: item.relationId
//         }
//       })
//     }
//   })
// }
const validateChange = formOrStatus => {
  if (formOrStatus === 'error') {
    data.isNext = false
    data.toRequiredRs = false
  } else {
    if (data.isNext) {
      data.current++
      data.toRequired = data.current
    }
    data.isNext = false
  }
}
// 下一步
const next = async () => {
  const validate = await formRef.value.validateChange()
  if (!validate) return
  const params = {
    ucPatientId: props.params.ucPatientId,
    ucDoctorId: props.params.ucDoctorId
    // reserveDate: data.form.reserveDate
  }
  // 确定提交钱的二次确认
  const result = await queryCureReserveVO(params)
  if (result) {
    // revisitType  1 线上问诊 2 门诊就诊
    // reserveDateDetail 1：上午  2：下午
    const { reserveDateStr, revisitType, reserveDateDetail } = result
    const curTI = () => {
      const ti = reserveDateDetail === 1 ? '上午' : '下午'
      return reserveDateStr + ' ' + ti
    }
    const newsTI = () => {
      let date = '',
        ti = ''
      const { reserveDate, reserveDateDetail } = data.form
      if (reserveDate) {
        date = reserveDate.split(' ')[0] || ''
        ti = reserveDateDetail === 1 ? '上午' : '下午'
      }
      return date && ti ? date + ' ' + ti : null
    }
    const params = {
      news: {
        method: data.form.revisitType === 1 ? '线上问诊' : '门诊就诊',
        date: newsTI()
      },
      cur: {
        method: revisitType === 1 ? '线上问诊' : '门诊就诊',
        date: curTI()
      }
    }
    // NOTE: 打开弹窗
    ModalTipsDOM.value.onOpen(params)
  } else {
    checkDoctorAppoint()
  }
}
const ModalTipsDOM = ref()
// 弹窗确定后的内容
function checkDoctorAppoint() {
  const imgUrlList = data.form.imgUrlList || []
  const ocrImgUrlList = data.form.ocrImgUrlList || []
  if (imgUrlList.length > 20) {
    return message.error('最多只能选择20张病历图片')
  } else {
    data.isNext = true
    data.toRequired++
  }
  if (ocrImgUrlList.length > 1) {
    return message.error('最多只能选择1张处方图片')
  } else {
    data.isNext = true
    data.toRequired++
  }
}
const isShowDrugtype = e => {
  data.isShowDrugtype = e > 0 ? 'drugCheck' : 'drugInput'
}

const selectChange = (e, key, options) => {
  if (key === 'prescriptionInfo.activityId') {
    isShowDrugtype(e)
    //参与活动
    if (e > 0) {
      const dataOptions = options.find(item => item.value == e)
      data.form.prescriptionInfo.activityName = dataOptions.label
      // ativityMedicationList(e)
    } else {
      //不参与活动
      data.form.prescriptionInfo.activityName = ''
    }
    //触发校验
    data.toRequired++
  }
}
const ocrImgUrlList = ref({})
const pendingOcrUrl = ref(null)

// 通过图片 URL 拉取 Blob 并复用现有 watcher → recPrescriptionOcr 链路
const _doOcrFromUrl = async url => {
  try {
    const isDrstrong = (() => {
      try {
        const { hostname } = new URL(url)
        return hostname === 'drstrong.cn' || hostname.endsWith('.drstrong.cn')
      } catch {
        return false
      }
    })()
    const res = await axios.get(url, {
      responseType: 'blob',
      ...(isDrstrong ? { headers: { [TokenKey]: getToken() } } : {})
    })
    const blob = res.data
    const rawFile = new File([blob], 'prescription.jpg', { type: blob.type || 'image/jpeg' })
    ocrImgUrlList.value = {
      fileData: [{ path: url, name: 'prescription.jpg' }],
      rawFile,
      type: 'ocrUpload'
    }
    console.log('ocrImgUrlList', ocrImgUrlList)
    data.form.ocrImgUrlList = [{ filePath: url, fileName: 'prescription.jpg' }]
  } catch (error) {
    console.error('URL OCR 识别失败', error)
  }
}

// 外部调用入口：存储待执行的 OCR URL，等初始化完成后由 assignFormData 触发
const triggerOcrFromUrl = url => {
  pendingOcrUrl.value = url
}

// im图片右键上传处方数据
const triggerFileUpload = params => {
  console.log(11111, params)
  ocrImgUrlList.value = params
}
watch(
  () => data.form.ocrImgUrlList,
  val => {
    if (val && val.length !== 0) {
      const { rawFile, type } = ocrImgUrlList.value
      // 无 rawFile 时说明是 handleOcrResult 的深层变更回调，直接忽略防止死循环
      if (!rawFile) return
      // 消费后立即清空，避免后续深层变更再次触发 OCR
      ocrImgUrlList.value = {}
      recPrescriptionOcr({
        rawFile,
        type
      })
    }
  },
  { deep: true, immediate: true }
)

// 上传处方回填
const backFillUploadPic = () => {
  const { fileData } = ocrImgUrlList.value
  data.form.ocrImgUrlList = fileData?.map(it => {
    return {
      filePath: it.path,
      fileName: it.name
    }
  })
}

// 查询医生是否备案过
const doctorPassStatus = async () => {
  const ucDoctorId = props.params?.ucDoctorId || curOrder.value.doctorInfo?.ucUserId || null
  const res = await queryDoctorPass({ ucDoctorId })
  const { recordPassStatus } = res || {} //是否备案成功过0:备案未成功过，1：备案成功过
  // 未备案成功过，复诊方式默认门诊就诊且不可修改
  data.doctorRecordPassed = Number(recordPassStatus) !== 1
  if (data.doctorRecordPassed && !data.notNeedReserve) {
    data.form.revisitType = 2
  }
}

// 处理OCR识别结果并填充表单
const handleOcrResult = async ocrResult => {
  console.log('OCR识别结果:', ocrResult)
  // 解构OCR识别结果
  const {
    diagnosisList,
    drugItems,
    hospital,
    doctorName,
    success,
    recognizeStatusStr,
    ocrRecordId,
    imageName,
    recognizeStatus,
    prescriptionTime
  } = ocrResult || {}
  console.log('ocr识别结束后', data.form.ocrImgUrlList)
  // 将OCR识别出来的imageName回填到ocrImgUrlList的fileName
  if (imageName && data.form.ocrImgUrlList && data.form.ocrImgUrlList.length > 0) {
    data.form.ocrImgUrlList[0].fileName = imageName
    data.form.ocrImgUrlList[0].businessId = ocrRecordId
  }

  // 识别状态：1-识别成功，2-其他类型处方识别暂未开通，3-无法识别，4-已上传过，5-未识别完整
  if (![1, 5].includes(recognizeStatus)) {
    message.error(recognizeStatusStr)
    return
  }

  // orc识别成功，重置对应表单项
  data.allDiagnose = []
  data.form = {
    ...data.form,
    scanOcrType: 1,
    description: '',
    hospitalName: '',
    offlineDoctorName: '',
    reserveDate: '',
    offlineDiagnosis: [],
    group_0: null,
    revisitType: null,
    drugInput: [
      {
        name: '',
        amount: ''
      }
    ],
    isOpenDrug: true, // 确保药品开关开启
    inquiryTime: '',
    ocrBusinessId: ''
  }

  // 填充医院名称
  if (hospital) {
    data.form.hospitalName = hospital
  }

  // 填充医生名称
  if (doctorName) {
    data.form.offlineDoctorName = doctorName
  }

  // 填充诊断信息（覆盖原有诊断）
  if (diagnosisList && diagnosisList.length > 0) {
    // 将诊断转换为组件需要的格式，并将诊断类型存入缓存
    const newDiagnosisList = diagnosisList
      .filter(item => item.type !== 3)
      .map(item => {
        data.diagnosisCache.set(item.diagnosisId, item.diagnosisType)
        return {
          label: item.diagnosisName,
          value: item.diagnosisId,
          type: item.diagnosisType
        }
      })
    // 根据第一个诊断的类型查询复诊建议日期
    const date = await diagnosisReconsultDate({
      diagnosisId: diagnosisList[0].diagnosisId,
      diagnosisType: diagnosisList[0].diagnosisType
    })
    data.form.reserveDate = date ? date : moment().add(14, 'days').format('YYYY-MM-DD')
    data.notNeedReserve = false
    data.modifyReserveDateFlag = 1
    data.form.offlineDiagnosis = newDiagnosisList
    data.allDiagnose = newDiagnosisList
    // 同步到搜索诊断选择框（group_0）
    data.form.group_0 = newDiagnosisList
    data.form.revisitType = 2 // 默认门诊就诊
  }

  // 填充药品信息
  if (drugItems && drugItems.length > 0) {
    data.form.drugInput = drugItems.map(med => ({
      name: med.name || med,
      amount: med.amount || 1
    }))
    data.activeKey = drugItems.length
  }
  // OCR场景下，初始化表单列表以显示OCR专属字段（就诊医院、就诊医生）
  initFormList(data.form.isOpenDrug)

  // 填充就诊时间
  if (prescriptionTime) {
    data.form.inquiryTime = moment(prescriptionTime).format('YYYY-MM-DD')
  }
  data.form.ocrBusinessId = ocrRecordId
  const status = success ? 'success' : 'error'
  message[status](recognizeStatusStr)
  formRef.value.validateChange()
}

// 处方 OCR 识别回调
const recPrescriptionOcr = async payload => {
  if (!payload) return

  // 处理清空OCR表单数据的请求
  if (payload.type === 'ocrClear') {
    clearOcrFormData()
    return
  }
  const hide = message.loading('识别中(约 5-8秒)，请耐心等待~', 0)
  try {
    const { rawFile } = payload
    const ucPatientId = props.params?.ucPatientId || curOrder.value.patientInfo?.ucUserId || null
    const ucDoctorId = props.params?.ucDoctorId || curOrder.value.doctorInfo?.ucUserId || null
    const doctorId = props.params?.doctorId || curOrder.value.doctorInfo.businessId
    const patientId = props.params?.patientId || curOrder.value.patientInfo.businessId
    const ocrFormData = new FormData()
    ocrFormData.append('file', rawFile)
    const params = {
      query: `ucDoctorId=${ucDoctorId}&ucPatientId=${ucPatientId}&doctorId=${doctorId}&patientId=${patientId}`,
      params: ocrFormData
    }
    const result = await recognizePrescriptionOcr(params)
    hide()
    // 直接处理识别结果
    handleOcrResult(result)
  } catch (error) {
    hide()
    console.log('OCR识别失败', error)
  }
}

// 清空OCR相关的表单数据
const clearOcrFormData = () => {
  // 保存当前的isOpenDrug状态
  const currentIsOpenDrug = data.form.isOpenDrug

  // 重置OCR相关字段
  data.form.scanOcrType = 0
  // 只有在isOpenDrug=false时才清空就诊医院和就诊医生
  if (!currentIsOpenDrug) {
    data.form.hospitalName = ''
    data.form.offlineDoctorName = ''
  }
  data.form.reserveDate = ''
  data.form.reserveDateDetail = ''
  // 医生未备案时，复诊方式默认门诊就诊且不可修改
  data.form.revisitType = data.doctorRecordPassed ? 2 : null
  data.form.offlineDiagnosis = []
  data.form.group_0 = null
  data.form.drugInput = [{ name: '', amount: '' }]
  data.form.isOpenDrug = false
  data.form.inquiryTime = ''
  data.form.ocrBusinessId = ''
  data.form.description = ''

  // 重置相关状态
  data.notNeedReserve = false
  data.modifyReserveDateFlag = 0
  data.allDiagnose = []
  data.diagnosisCache.clear()

  // 重新初始化表单列表，隐藏OCR专属字段
  initFormList(false)

  // 清除验证错误状态
  nextTick(() => {
    formRef.value?.clearValidForTreat()
    formRef.value?.validateChange()
  })
}

const initFormData = () => {
  formData()
}

function diagnosisValidatePass(rule, values = []) {
  const reg = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g
  if (values?.length <= 0) {
    return Promise.reject('诊断名称为必填项')
  } else {
    const has = values.some(item => reg.test(item.label))
    if (has) {
      return Promise.reject('禁止输入表情')
    }
  }
  return Promise.resolve()
}
function checkValidatePass(rule, values) {
  const { activityId = 0 } = data.form?.prescriptionInfo || {}
  const drugCheckValues = values[activityId]
  if (activityId > 0) {
    if (!drugCheckValues || drugCheckValues.length <= 0) {
      return Promise.reject('处方药品为必填项')
    }
  }
  return Promise.resolve()
}
function validatePass(rule, values) {
  const reg = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g
  //去除数组中空的数据
  if (values) {
    values = values.filter(str => !!str)
    const { activityId = 0 } = data.form?.prescriptionInfo || {}
    if (activityId === 0) {
      if (values.every(v => !v)) {
        return Promise.reject('处方药品为必填项')
      } else {
        if (new Set(values).size != values.length) {
          return Promise.reject('有重复的药品名称')
        } else {
          const has = values.some(item => reg.test(item))
          if (has) {
            return Promise.reject('禁止输入表情')
          }
          // OCR场景下验证药品数量
          if (data.form.scanOcrType === 1 && data.form.drugInput) {
            const hasEmptyAmount = data.form.drugInput.some(drug => !drug.name || !drug.amount)
            if (hasEmptyAmount) {
              return Promise.reject('处方药品名称和数量均为必填项')
            }
          }
          return Promise.resolve()
        }
      }
    }
  } else {
    return Promise.resolve()
  }
}
//增加
const drugAdd = () => {
  if (data.activeKey < 10) {
    data.activeKey = ++data.activeKey
    // 初始化新药品对象（包含名称和数量）
    data.form.drugInput.push({
      name: '',
      amount: 1
    })
  } else {
    message.error('最多添加十个药品！')
  }
}
//删除
const drugDel = i => {
  data.activeKey--
  data.form.drugInput.splice(i, 1)
}

// 静态方法赋值表单
const assignFormData = ctxRes => {
  data.loading = false
  data.offlineCaseDetail = ctxRes
  //编辑状态存储诊断类型map对象
  const { prescriptionInfo = null, imgUrlList = [] } = ctxRes || {}
  const diagnosisList = (ctxRes.diagnosisList || []).filter(it => it.diagnosisType !== 3)
  diagnosisList.forEach(item => data.diagnosisCache.set(item.diagnosisId, item.diagnosisType))
  const { prescriptionImages = [] } = prescriptionInfo || {}
  //如果处方图片有就拼接处方图片 病历图片可最大显示 18张
  if (prescriptionImages && prescriptionImages.length > 0) {
    ctxRes.imgUrlList = imgUrlList.concat(prescriptionImages)
  }
  formData(ctxRes).then(() => {
    if (pendingOcrUrl.value) {
      _doOcrFromUrl(pendingOcrUrl.value)
      pendingOcrUrl.value = null
    }
  })
}
// 获取编辑信息
const offlineCaseDetail = () => {
  if (props.id) {
    offLineRecordDetail({ id: props.id }).then((res = {}) => {
      assignFormData(res)
      // 获取历史诊断数据
      getHistoryDiagnosis()
    })
  } else {
    initFormData()
  }
}
const innitImgs = (res, key) => {
  if (res && res[key] && res[key].length > 0) {
    const urls = res[key].map((item, index) => {
      return {
        uid: -index,
        url: item
      }
    })
    return urls
  }
}
const prev = () => {
  data.current--
  data.toRequired = data.current
}

const offlineCaseInit = () => {
  return new Promise(resolve => {
    const params = {
      ucPatientId: Number(props.params.ucPatientId),
      ucDoctorId: props.params.ucDoctorId
    }
    //获取病历初始化信息
    getOfflineCaseInit(params).then(res => {
      const dataKey = {
        patientName: '',
        patientAge: '',
        patientGender: ''
      }
      for (const key in dataKey) {
        data.form[key] = res[key]
      }
      resolve()
    })
  })
}
//初始化数据
const reSetData = (hasId = '') => {
  data.activeKey = 1
  data.current = 0
  data.toRequired = 0
  data.diagnoseSelect = 0
  data.form = {}
  data.offlineCaseDetail = ''
  data.notNeedReserve = false
  data.expend = Boolean(hasId)
  Boolean(hasId) && effectFormItemVisible(true)
  isShowDrugtype(0)
  //清除缓存,是否对患者隐藏
  // sessionStorage.removeItem('patientPermission')
}
const resetUseComponent = () => {
  data.medicalHistoryList.forEach(item => {
    if (effectShow.includes(item.key)) {
      item.isExpend = false
    }
  })
}
//设置诊断的输入大小
const setIptMaxLength = () => {
  nextTick(() => {
    const input = document.querySelector('#giftNameLimit')
    if (!input) return
    if (data.diagnoseSelect == 2) {
      if (data.allDiagnose.length >= 10) {
        input.setAttribute('maxLength', 0)
      } else {
        input.setAttribute('maxLength', 30)
      }
    } else {
      input.setAttribute('maxLength', 50)
    }
  })
}

// 关闭时保存未保存内容
const curDocAssInfo = computed(() => store.state.workOrder.workOrderGroupInfo.curDocAss)
const assId = curDocAssInfo.value?.ucUserId
const docId = computed(() => props.params.ucDoctorId)
const patId = computed(() => props.params.ucPatientId)
const cancelClick = () => {
  // 新增关闭时时数据缓存
  if (!props.id) {
    saveData().then(res => {
      const storageRecord = JSON.parse(sessionStorage.getItem(`SESSION_MEDICAL_RECORD`) || '{}')
      sessionStorage.setItem(
        `SESSION_MEDICAL_RECORD`,
        JSON.stringify({
          ...storageRecord,
          [`${patId.value}-${docId.value}-${assId}-MedicalRecord`]: {
            ...res,
            notNeedReserve: data.notNeedReserve
          }
        })
      )
      console.log(
        '关闭时保存的诊疗记录',
        storageRecord[`${patId.value}-${docId.value}-${assId}-MedicalRecord`]
      )
      emit('cancelClick')
    })
  } else {
    emit('cancelClick')
  }
  data.form = {}
}

const reverseDatelimit = ref(null)
// 判断缓存中是否包含 健管-患者-医生 对应的未保存诊疗记录
const calcRecordInStorage = async () => {
  const storageRecord = JSON.parse(sessionStorage.getItem(`SESSION_MEDICAL_RECORD`) || '{}')
  const curStorageRecord =
    storageRecord[`${patId.value}-${docId.value}-${assId}-MedicalRecord`] || {}
  console.log('【暂存的curStorageRecord】', curStorageRecord)
  curStorageRecord.diagnosisList = (curStorageRecord.diagnosisList || []).filter(
    it => it.diagnosisType !== 3
  )
  data.notNeedReserve = curStorageRecord.notNeedReserve
  const recentDiagnosis = []
  const storageDontHasDiagnosis =
    !curStorageRecord?.diagnosisList || !curStorageRecord?.diagnosisList?.length
  // 缓存中无诊断
  if (storageDontHasDiagnosis) {
    const res = await recentDiagnosisInfo({
      doctorId: Number(props.params?.doctorId || curOrder.value.doctorInfo.businessId),
      patientId: Number(props.params?.patientId || curOrder.value.patientInfo.businessId)
    })
    if (res && res.length) {
      res.forEach(item => {
        recentDiagnosis.push({
          diagnosisId: item.id,
          diagnosisName: item.name,
          diagnosisType: item.diagnosisType
        })
      })
    }
  }

  const storegeReverseDate = curStorageRecord.reserveDate || ''
  // 缓存中是否有复诊日期
  const { defaultCureDate, limitCureDate } = await queryLimitAndDefaultDate()
  reverseDatelimit.value = limitCureDate // 从某个日期可以开始选择
  let ctxReserveDate = null
  if (!storegeReverseDate) {
    ctxReserveDate = defaultCureDate
  } else {
    // 如果有复诊日期，判断缓存的复诊日期是否有效
    if (moment(storegeReverseDate).isSameOrAfter(limitCureDate)) {
      ctxReserveDate = storegeReverseDate
    } else {
      ctxReserveDate = defaultCureDate
    }
  }

  const _diagnosisList = storageDontHasDiagnosis ? recentDiagnosis : curStorageRecord.diagnosisList
  assignFormData({
    ...data.form,
    ...curStorageRecord,
    reserveDate: ctxReserveDate,
    patientPermission: Boolean(curStorageRecord?.patientPermission),
    doctorPermission: Boolean(
      [null, undefined].includes(curStorageRecord?.doctorPermission)
        ? 1
        : curStorageRecord?.doctorPermission
    ),
    diagnosisList: _diagnosisList.filter(it => it.diagnosisType !== 3)
  })
  effectFormItemVisible(false)
}

const doctorInProject = ref(false)
const calcDoctorIsJoinProject = async () => {
  const { joinFlag = false } = await isDoctorJoinProject({
    ucDoctorId: Number(props.params.ucDoctorId)
  })
  doctorInProject.value = joinFlag
  return joinFlag
}

// 判断是否预病历逻辑
const PreDetailIllness = () => {
  isDetailIllnessPre({
    ucPatientId: Number(props.params.ucPatientId),
    ucDoctorId: Number(props.params.ucDoctorId)
  }).then(res => {
    // 走 offLineRecordDetail 赋值逻辑
    const { preOfflineIsExist } = res
    data.preId = ''
    const { id, ...others } = res
    console.log('【是否走缓存】', preOfflineIsExist ? '否' : '是')
    if (preOfflineIsExist) {
      assignFormData({
        ...others,
        preId: id
      })
    } else {
      console.log('缓存逻辑====》')
      calcRecordInStorage()
    }
    id && (data.preId = id)
  })
}
// 删除门诊病历
const deleteRecord = () => {
  Modal.confirm({
    title: '确定删除诊疗记录',
    icon: createVNode(ExclamationCircleOutlined),
    content: '删除此诊疗记录后，所有相关复诊预约将同步失效，且操作不可撤销，请您确认是否执行删除？',
    okText: '确认',
    cancelText: '取消',
    centered: true,
    onOk: () => {
      deleteMedicalRecord({ patientDiseaseId: props.id }).then(() => {
        message.success('操作成功')
        emit('savaData')
      })
    },
    onCancel: () => {
      // emit('cancelClick')
    }
  })
}
// 选择就诊人
const handleSelect = patientInfo => {
  data.form.patientProfileId = patientInfo.patientProfileId
}
// 只有多个就诊人才需要展示选择就诊人组件
const checkMultPatient = () => {
  const ucPatientId = props.params.ucPatientId
  if (!ucPatientId) return
  getProfileList({ ucPatientId }).then(res => {
    const showSelectPatient = res && res.length > 1
    if (showSelectPatient) {
      data.medicalHistoryList = [...medicalHistoryList]
    } else {
      data.medicalHistoryList = [...medicalHistoryList].filter(it => it.key !== 'patientProfile')
    }
  })
}
// 动态设置表单项
const handleFormLabel = () => {
  if (props.id) {
    // 修改补充诊疗记录时，不支持选择就诊人
    data.medicalHistoryList = [...medicalHistoryList].filter(it => it.key !== 'patientProfile')
  } else {
    checkMultPatient()
  }
}
watch(
  () => [data.current, props.id, props.visible],
  (newValue, oldValue) => {
    data.current = newValue[0]
    handleFormLabel()
    if (newValue[2] !== oldValue[2] && newValue[2] == true) {
      data.loading = true
      setIptMaxLength()
      resetUseComponent()
      console.log('props.id', props.id)
      reSetData(props.id)
      offlineCaseDetail()
      fetchReverseList()
      //获取默认复诊日期
      if (!props.id) {
        data.loading = false
        // 是否修改复诊日期值重置
        data.modifyReserveDateFlag = 0
        // 兼容病历初始化内容和预病历内容
        // 先获取医生是否在项目中，再执行预病历逻辑
        calcDoctorIsJoinProject().then(() => {
          offlineCaseInit().then(() => {
            PreDetailIllness()
          })
        })
        getHistoryDiagnosis()
      } else {
        calcDoctorIsJoinProject()
      }
      doctorPassStatus()
    }
  }
)

defineExpose({
  triggerFileUpload,
  triggerOcrFromUrl
})
</script>
<style scoped lang="scss">
@import './medicalRecordsPoup.scss';
</style>
